export default class ClientOnboarding {
  // eslint-disable-next-line max-lines-per-function
  constructor() {
    this.activeTab = 'refAccountInfo';

    this.id = null;

    this.personalInfo = {
      firstName: null,
      lastName: null,
      contactInfo: {
        phone1: null,
        email1: null,
      },

      riaUserId: null,
      riaUserIdBackup: null,
      dashboardAccess: true,
      riskTolerance: 50,
      custodian: null,
      repCode: null,
      segmentId: null,
      roboStatus: false,

      clientSettings: {
        openAccount: false,
        // This is behavioral risk tolerance. Risk tolerance is out of this object
        behavioralRiskTolerance: true,
      },

      legalAddress: {
        addressLine1: null,
        addressLine2: null,
        country: null,
        city: null,
        state: null,
        zip: null,
      },

      mailingAddress: {
        mailingActive: 1,
        addressLine1: null,
        addressLine2: null,
        city: null,
        country: null,
        state: null,
        zip: null,
      },
    };

    this.selectedAccount = {
      accountTypeId: null,
      accountTypeName: null,
      accountType: null,
    };

    this.selectedGoal = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      segment_goal_Id: null,
      display_type: null,
      goal_name: null,
      targetDate: null,
      retirementAge: null,
    };

    this.workflowDoc = {
      wfId: null,
      wfName: null,
    };

    this.employeeInfo = {
      employmentStatus: null,
      employerName: null,
      occupation: null,
      sourceOfIncome: null,
      address: {
        streetAddress: [],
        city: null,
        state: null,
        postalCode: null,
      },
    };

    this.employementSettings = {
      tradedCompanyToggle: false,
      tradedCompanyModal: false,
      firmAssociationToggle: false,
      firmAssociationModal: false,
      publicOfficialToggle: false,
      publicOfficialModal: false,
    };

    this.tradedCompanyInfo = {
      companyName: null,
      tickerSymbol: null,
      companyAddress: null,
      city: null,
      stateAbbreviation: null,
      postalCode: null,
    };

    /**
     * This maps to exchangeEntity of disclosures
     */
    this.firmAssociationInfo = {
      exchangeEntityName: null,
      authorizationFileName: null,
      authorizationFileFormat: null,
      authorizationFileBase64: null,
    };

    this.publicOfficialInfo = {
      countryCodeISOAlpha2: null,
      officialName: null,
      officialOrganization: null,
      officialTitle: null,
      relationship: null,
    };

    this.defaultDisclosure = {
      tradedCompanyInfo: {
        companyName: null,
        tickerSymbol: null,
        companyAddress: null,
        city: null,
        stateAbbreviation: null,
        postalCode: null,
        disable: this.employementSettings.tradedCompanyToggle,
      },

      firmAssociationInfo: {
        exchangeEntityName: null,
        authorizationFileName: null,
        authorizationFileFormat: null,
        authorizationFileBase64: null,
        disable: this.employementSettings.firmAssociationToggle,
      },

      publicOfficialInfo: {
        countryCodeISOAlpha2: null,
        officialName: null,
        officialOrganization: null,
        officialTitle: null,
        relationship: null,
        disable: this.employementSettings.publicOfficialToggle,
      },
    };

    this.designatedBeneficiaries = [];

    this.designateBeneficiary = {
      maritalStatus: null,
      addBeneficiaries: false,
      addTrustedContact: false,
    };

    this.investmentProfile = {
      annualIncomeUSD: {
        min: null,
        max: null,
      },
      federalTaxBracketPercent: 39.6,
      liquidNetWorthUSD: {
        min: null,
        max: null,
      },
      totalNetWorthUSD: {
        min: null,
        max: null,
      },
    };
    this.designatedTrustedContact = [];

    this.trustedContact = {
      firstName: null,
      lastName: null,
      phoneNumber: {
        phoneNumberType: null,
        phoneNumber: null,
      },
      emailAddress: null,
    };

    this.dividendSetting = null;
  }
}
